const matchingMode = {
  label: 'Volunteer matching',
  kind: 'select',
  default: 'default',
  options: [
    { value: 'default', label: 'Everyone' },
    { value: 'branch', label: 'Match by branch' },
    { value: 'any_descendent', label: `Any organisation below user's organisation` },
  ],
  description:
    'You can optionally choose to match volunteers to the people they are calling, based on their organisational unit.',
}

const organisationKinds = JSON.parse(window.ENV.ORGANISATION_KINDS)
const matchingModeOrganisationKind = {
  label: 'Matching organisation type',
  kind: 'select',
  required: true,
  dependsOn: {
    matchingMode: ['organisation'],
  },
  options: [
    { label: '-- Select one --', value: 'not-selected' },
    ...organisationKinds.map(kind => ({
      label: kind.label,
      value: kind.external_type,
    })),
  ],
  description:
    "Choose which kind of organisation to match volunteers and people based on",
}

const userChoiceMode = {
  label: 'Volunteer targeting',
  kind: 'select',
  default: 'none',
  options: [
    { value: 'none', label: 'None' },
    { value: 'all', label: 'Any organisation' },
    { value: 'accessible', label: `Any organisation beneath their own` },
  ],
  description:
    'You can optionally choose to let volunteers select which organisational unit they would like to call.',
}

export { matchingMode, matchingModeOrganisationKind, userChoiceMode }
